/**
 * @generated SignedSource<<3c5ec5b71b000c88561403949f1c567d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type countryCountriesFragment$data = ReadonlyArray<{
  readonly node: {
    readonly id: string;
    readonly name: string;
    readonly isoCodeTwo: string;
    readonly isoCodeThree: string;
    readonly continentName: string;
    readonly currency: string | null;
    readonly currencySymbol: string | null;
    readonly regions: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
  } | null;
  readonly " $fragmentType": "countryCountriesFragment";
}>;
export type countryCountriesFragment$key = ReadonlyArray<{
  readonly " $data"?: countryCountriesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"countryCountriesFragment">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "countryCountriesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Country",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoCodeTwo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isoCodeThree",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "continentName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currencySymbol",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "regions",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CountryEdge",
  "abstractKey": null
};
})();

(node as any).hash = "86d6f8987c2abe75783d14325d5a959b";

export default node;
